export default __webpack_public_path__ + "static/media/sensotrend_signin_create_account.b6dd2a5f.png";